import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "carousel-card" }
const _hoisted_4 = { class: "carousel-card__image" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "carousel-card__content" }
const _hoisted_7 = { class: "carousel-card__content-title" }
const _hoisted_8 = { class: "carousel-card__content-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RcSwiper = _resolveComponent("RcSwiper")!

  return (_ctx.personsList.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({'content-block': !_ctx.previewModeOnly})
      }, [
        (!_ctx.previewModeOnly)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_1, " Friends and People "))
          : _createCommentVNode("", true),
        (!_ctx.previewModeOnly)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.description), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_RcSwiper, {
          items: _ctx.personsList,
          class: _normalizeClass({'friends-carousel': !_ctx.previewModeOnly})
        }, {
          slide: _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: item.image,
                  alt: ""
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("strong", null, _toDisplayString(item.match) + "%", 1),
                  _cache[0] || (_cache[0] = _createTextVNode(" Match "))
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["items", "class"])
      ], 2))
    : _createCommentVNode("", true)
}